<div class="title">
  <div class="header">
    <h2>{{ header || (headerKey | locLabel) }}</h2>
    <ng-content select="[custom-data]"></ng-content>
  </div>
  <button mat-icon-button class="close-icon" [mat-dialog-close]="false" type="button" *ngIf="showCloseButton">
    <mat-icon inline>close</mat-icon>
  </button>
</div>
<mat-divider class="dialog-divider"></mat-divider>
